import React, { useState, useContext, useEffect, useRef } from "react";
import "../../styles/shoppingCart.scss";
import { Form, Formik } from "formik";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";
import {
  CART_STEP,
  PAYMENT_METHOD,
  CartContext,
} from "../../contexts/CartContext";
import _ from "lodash";

import { ReactComponent as ArrowLeftSvg } from "../../assets/workExchange/arrow-left-shopping.svg";
import { ReactComponent as TrueMoneyIdleSvg } from "../../assets/payment/truemoney-idle.svg";
import { ReactComponent as TrueMoneyActiveSvg } from "../../assets/payment/truemoney-active.svg";
import { ReactComponent as CreditCardIdleSvg } from "../../assets/payment/credit-card-idle.svg";
import { ReactComponent as CreditCardActiveSvg } from "../../assets/payment/credit-card-active.svg";
import { ReactComponent as QRIdleSvg } from "../../assets/payment/qrcode-idle.svg";
import { ReactComponent as QRActiveSvg } from "../../assets/payment/qrcode-active.svg";
import { ReactComponent as VisaSvg } from "../../assets/payment/visa.svg";
import { ReactComponent as MasterCardSvg } from "../../assets/payment/mastercard.svg";
import { ReactComponent as UnionPaySvg } from "../../assets/payment/unionpay.svg";
import { ReactComponent as JcbSvg } from "../../assets/payment/jcb.svg";
import { ReactComponent as AlarmIcon } from "../../assets/workExchange/alarm-icon.svg";
import { ReactComponent as SelectedSvg } from "../../assets/workExchange/icon-selected.svg";
import { ReactComponent as LoadingSvg } from "../../assets/icons/loading-icon.svg";
import TextBox from "../common/TextBox";

const PaymentForm = (props) => {
  const { getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationShoppingCart = getLang(langComponent.chat);
  const TranslationWorkExchange = getLang(langComponent.workExchange);
  const {
    setCardDetails,
    setStep,
    setPaymentMethod,
    charge,
    paymentMethod,
    chargeExpiresIn,
    journal,
  } = useContext(CartContext);

  const tabs = [
    {
      icon: <CreditCardIdleSvg />,
      iconActive: <CreditCardActiveSvg width={18} />,
      value: PAYMENT_METHOD.CARD,
      name: TranslationShoppingCart("Credit Card"),
      disabeld: false,
    },
    {
      icon: <TrueMoneyIdleSvg />,
      iconActive: <TrueMoneyActiveSvg width={18} />,
      value: PAYMENT_METHOD.TRUEMONEY,
      name: TranslationShoppingCart("TrueMoney"),
      disabeld: false,
    },
    {
      icon: <QRIdleSvg />,
      iconActive: <QRActiveSvg width={14} />,
      value: PAYMENT_METHOD.QR,
      name: TranslationShoppingCart("QR Code"),
      disabeld: false,
    },
  ];

  const handleSetTab = async (tab) => {
    await setPaymentMethod(tab);
  };

  const _getTimeLeft = () => {
    const hours = Math.floor(chargeExpiresIn / 3600).toString();
    const minutes = Math.floor((chargeExpiresIn % 3600) / 60).toString();
    const seconds = Math.floor(chargeExpiresIn % 60).toString();

    return `${hours}h ${minutes}m ${seconds}s`;
  };

  const handleBackToItemCart = () => {
    // TODO: Delete journal
    setStep(CART_STEP.INFO);
    setPaymentMethod(undefined);
  };

  const _getCardType = (cardNumber) => {
    // Remove all non-digit characters from the input
    const sanitized = cardNumber.replace(/\D/g, "");

    // Regex patterns for various card types
    const cardPatterns = {
      visa: /^4\d{12}(\d{3})?$/,
      mastercard:
        /^(5[1-5]\d{4}|222[1-9]|22[3-9]\d{3}|2[3-6]\d{4}|27[01]\d{2}|2720)\d{10}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      unionpay: /^(62\d{14,17}|6[5-9]\d{13,18})$/,
    };

    // Check the card number against each pattern
    for (const [cardType, pattern] of Object.entries(cardPatterns)) {
      if (pattern.test(sanitized)) {
        return cardType;
      }
    }

    // If no pattern matches, return 'unknown'
    return "unknown";
  };

  return (
    <div className="cart-content-payment">
      <div
        className="cart-content-payment-return"
        onClick={handleBackToItemCart}
      >
        <ArrowLeftSvg height={12} /> {TranslationCommon("Back")}
      </div>
      <div className="cart-content-payment-title">
        {TranslationWorkExchange("Payment method")}
      </div>
      <div className="cart-content-payment-types">
        {tabs.map((t) => {
          const active = paymentMethod === t.value;

          if (
            t.value === PAYMENT_METHOD.TRUEMONEY &&
            journal.grandTotal > 50000
          ) {
            return null;
          }

          return (
            <div
              className={`cart-content-payment-types-item ${
                active ? "cart-content-payment-types-item--active" : ""
              } `}
              onClick={() => {
                handleSetTab(t.value);
              }}
              key={t.value}
            >
              <div className="cart-content-payment-types-item__icon">
                <SelectedSvg width={20} />
              </div>
              <div className="cart-content-payment-types-item-name">
                <div className="cart-content-payment-types-item-name__icon">
                  {t.iconActive}
                </div>
                <span>{t.name}</span>
              </div>
              {/* {t.disabeld && (
                <div className="cart-content-payment-types-item--coming-soon">
                  {TranslationCommon("Coming soon")}
                </div>
              )} */}
            </div>
          );
        })}
      </div>
      <div className="cart-content-payment-form">
        {paymentMethod === PAYMENT_METHOD.CARD && (
          <Formik
            initialValues={{
              cardNo: "",
              expiration: "",
              name: "",
              cvv: "",
            }}
            validate={({ cardNo, cvv, expiration, name }) => {
              let errors = {};

              if (!cardNo) errors.cardNo = "Please fill in your card number";
              if (!cvv) errors.cvv = "Please fill in the card's cvv";
              if (!expiration)
                errors.expiration =
                  "Please fill in your card's expiration date";
              if (!name) errors.name = "Please fill in cardholder's name";

              if (cardNo && cardNo.length < 16)
                errors.cardNo = "Invalid card number";

              if (!_.isEmpty(errors)) {
                return errors;
              }

              setCardDetails(cardNo.replace(/\D/g, ""), name, expiration, cvv);

              return errors;
            }}
          >
            {({ values }) => {
              const _cardType = _getCardType(values.cardNo);

              const getCardTypeClassname = (type) => {
                if (_cardType === type) {
                  return "cart-content-payment-form-card-types__icon cart-content-payment-form-card-types__icon--active";
                }

                return "cart-content-payment-form-card-types__icon";
              };

              return (
                <Form className="cart-content-payment-form">
                  <TextBox
                    name="name"
                    placeholder="Cardholder name"
                    label={TranslationShoppingCart("Name")}
                  />
                  <div className="cart-content-payment-form-card">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label className="cart-content-payment-form-card__title">
                        {TranslationShoppingCart("Credit Card Number")}
                      </label>
                      <div className="cart-content-payment-form-card-types">
                        <VisaSvg
                          className={getCardTypeClassname("visa")}
                          height={20}
                          width={20}
                        />
                        <MasterCardSvg
                          className={getCardTypeClassname("mastercard")}
                          height={20}
                          width={20}
                        />
                        <JcbSvg
                          className={getCardTypeClassname("jcb")}
                          height={20}
                          width={20}
                        />
                        <UnionPaySvg
                          className={getCardTypeClassname("unionpay")}
                          height={20}
                          width={20}
                        />
                      </div>
                    </div>
                    <TextBox
                      name="cardNo"
                      mask="9999 9999 9999 9999"
                      maskPlaceholder=""
                      placeholder="0000 0000 0000 0000"
                    />
                  </div>
                  <div className="cart-content-payment-form__split">
                    <TextBox
                      name="expiration"
                      mask="99/99"
                      maskPlaceholder=""
                      placeholder={TranslationWorkExchange("MM/YY")}
                      label={TranslationShoppingCart("Expiry Date")}
                    />
                    <TextBox
                      name="cvv"
                      mask="999"
                      maskPlaceholder=""
                      placeholder="000"
                      type="password"
                      label={TranslationShoppingCart("CVC")}
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
        {(paymentMethod === PAYMENT_METHOD.QR ||
          paymentMethod === PAYMENT_METHOD.TRUEMONEY) && (
          <div className="cart-content-payment-form-qr">
            {charge ? (
              <>
                <img
                  className="cart-content-payment-form-qr__image"
                  src={charge.downloadUri}
                  alt="promptpay-qr"
                  height={paymentMethod === PAYMENT_METHOD.QR ? 400 : 256}
                />
                <div className="cart-content-payment-form-qr__countdown">
                  {TranslationWorkExchange("Payment page expires in")}
                  <AlarmIcon />
                  {_getTimeLeft()}
                </div>
                <div className="cart-content-payment-form-qr__warning">
                  Please don't close this window.
                </div>
              </>
            ) : (
              <div className="cart-content-payment-form-qr-loading">
                <LoadingSvg />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

PaymentForm.propTypes = {};

export default PaymentForm;
